import { useEffect } from "react";
import { Link } from "react-router-dom";
import useStore from "../../features/store";
import Loading from "../../components/common/loading";
import InvalidComponentsForm from "../../components/dashboard/invalidComponentsForm";

const DashboardInvalidComponents = () => {
  const {
    invalidComponents,
    isLoadingInvalidComponents,
    fetchInvalidComponents,
  }: any = useStore();

  useEffect(() => {
    if (!invalidComponents) {
      fetchInvalidComponents();
    }
  }, [invalidComponents, fetchInvalidComponents]);

  return (
    <div className="my-10">
      <div className="breadcrumbs text-sm">
        <ul>
          <li>
            <Link to="/dashboard">داشبورد</Link>
          </li>
          <li className="font-[900]">فاکتورهای استخراج‌ نشده</li>
        </ul>
      </div>
      <div className="flex flex-col-reverse lg:flex-row items-start gap-3 relative">
        <div className="w-full lg:w-7/12">
          <h1 className="font-rokh font-[900] text-xl mt-10 mb-4">
            فاکتورهای استخراج‌ نشده:
          </h1>
          {isLoadingInvalidComponents ? (
            <Loading />
          ) : (
            <div>
              {invalidComponents?.invalid_components?.length > 0 &&
                invalidComponents?.invalid_components.map((comp: string) => (
                  <h6
                    key={comp}
                    className="border text-sm block rounded-lg p-3 mb-2"
                  >
                    {comp}
                  </h6>
                ))}
            </div>
          )}
        </div>

        <div className="w-full lg:w-5/12">
          <InvalidComponentsForm />
        </div>
      </div>
    </div>
  );
};

export default DashboardInvalidComponents;
